import { load } from 'recaptcha-v3';

/** Google reCAPTCHAのキー情報。 */
const RECAPTCHA_KEY = process.env["REACT_APP_GOOGLE_RECAPTCHA_KEY"] as string;

/** Google reCaptcha V3のトークンを取得する。 */
export async function getRecaptchaToken() {
  try {
    /** Google reCaptchaのインスタンス。 */
    const recaptcha = await load(RECAPTCHA_KEY);
    /** Google reCaptchaのトークン。 */
    const token = await recaptcha.execute('homepage');
    return token;
  }
  catch(e) {
    if(process.env['REACT_APP_STAGE_ENV'] === 'dev') {
      console.error("reCAPTCHA v3のトークン取得でエラーが発生しました。");
      console.error(e);
    }
    return "";
  }
}
